import ContactForm from "./ContactForm";
import FAQs from "./FAQs";
import OfficeAddress from "./OfficeAddress";

const ContactUs = () => {
  return (
    <div className="bg-white font-Manrope z-[-1]">
      <main className="overflow-hidden">
        {/* Header */}
        <div className="bg-natural-grey-100">
          <div className="py-24 lg:py-32">
            <div className="relative z-10 mx-auto max-w-7xl pl-4 pr-8 sm:px-6 lg:px-8">
              <h1 className="text-4xl font-bold tracking-tight text-warm-gray-900 sm:text-5xl lg:text-6xl">
                Reach Us
              </h1>
              <p className="mt-6 max-w-3xl text-xl text-warm-gray-500">
                Thank you for visiting our contact us page. We are always here
                to help with any questions or concerns you may have about our
                product.
              </p>
            </div>
          </div>
        </div>

        <ContactForm />

        {/* <OfficeAddress /> */}
        <FAQs />
      </main>
    </div>
  );
};

export default ContactUs;
